import { render, staticRenderFns } from "./Alumni_profile.vue?vue&type=template&id=c4d31850"
import script from "./Alumni_profile.vue?vue&type=script&lang=js"
export * from "./Alumni_profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports